namespace GeniuzPOS.InitialData {
    export class PsConnectEdcPortColumns {
        static columnsKey = 'InitialData.PsConnectEdcPort';
    }
}
